import { GatewayNetworkModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/networks/models/outputs/gateway-network.model';
import { DisplayColumnDef } from '@tanstack/react-table';

import { NetworkListActionsCell } from './network-list-actions';
import { NetworkListActionsHeader } from './network-list-actions.header';

export const NetworkListActionsColumn: DisplayColumnDef<
  GatewayNetworkModel,
  unknown
> = {
  id: 'actions',
  enableSorting: false,
  enableHiding: false,
  header: NetworkListActionsHeader,
  cell: NetworkListActionsCell,
};
